module.exports = __webpack_public_path__ + "img/picto-patient.615a23ff.svg";